<template>
  <section class="nx-cases" id="cases">
    <div class="nx-cases-container">
      <div class="nx-cases-header nx-animate-on-scroll">
        <p class="nx-cases-subtitle">{{ config?.cases?.subtitle }}</p>
        <h2 class="nx-cases-title">{{ config?.cases?.title }}</h2>
      </div>

      <!-- 查看更多按钮 -->
      <div class="nx-cases-more">
        <a href="javascript:void(0)" class="nx-cases-more-btn" @click="goToClassicCases">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 17L18 12L13 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 17L11 12L6 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>

      <div class="nx-cases-grid">
        <div
          v-for="(item, index) in filteredCases"
          :key="index"
          class="nx-case-card nx-card nx-animate-on-scroll"
        >
          <div class="nx-case-number">{{ String(index + 1).padStart(2, '0') }}</div>
          <h3 class="nx-case-title">{{ item.title }}</h3>
          <p class="nx-case-content">{{ item.content }}</p>
          <button class="nx-button nx-case-btn" @click="openCase(item.id)">查看详情 →</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NxCases',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    filteredCases() {
      return (this.config?.cases?.items || []).filter(item => item.id !== 0 && item.id !== 5).slice(0, 4);
    }
  },
  mounted() {
    // 组件已挂载，配置由父组件传递
  },
  methods: {
    openCase(id) {
      this.$emit('open-case', id);
    },
    goToClassicCases() {
      const url = window.location.origin + '/classic-cases';
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
};
</script>

<style scoped>
.nx-cases {
  position: relative;
  padding: 80px 40px;
  background: linear-gradient(180deg, #fafbfc 0%, #f5f7fa 100%);
  overflow: hidden;
}

.nx-cases::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 30% 20%, rgba(59, 130, 246, 0.04) 0%, transparent 50%),
    radial-gradient(circle at 70% 80%, rgba(139, 92, 246, 0.035) 0%, transparent 50%);
}

.nx-cases-container {
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.nx-cases-header {
  text-align: center;
  margin-bottom: 25px;
  position: relative;
}

/* 查看更多按钮 */
.nx-cases-more {
  position: absolute;
  top: 70px;
  right: 0;
}

.nx-cases-more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  background: linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%);
  border: 1.5px solid rgba(25, 118, 210, 0.2);
  color: #1976d2;
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow:
    0 2px 8px rgba(25, 118, 210, 0.08),
    inset 0 1px 2px rgba(255, 255, 255, 0.8);
  cursor: pointer;
}

.nx-cases-more-btn:hover {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  border-color: transparent;
  color: #fff;
  transform: translateX(4px);
  box-shadow:
    0 4px 15px rgba(25, 118, 210, 0.25),
    inset 0 0 0 transparent;
}

.nx-cases-more-btn svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.nx-cases-more-btn:hover svg {
  transform: translateX(2px);
}

.nx-cases-subtitle {
  font-size: 1.2rem;
  color: var(--nx-blue-primary);
  font-weight: 500;
  letter-spacing: 0.3rem;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
  text-shadow: 0 0 20px rgba(25, 118, 210, 0.25);
}

.nx-cases-title {
  font-size: clamp(32px, 4.5vw, 48px);
  font-weight: 800;
  color: var(--nx-text-title);
  margin-bottom: 12px;
  text-shadow: 0 0 30px rgba(13, 71, 161, 0.15),
    0 0 60px rgba(59, 130, 246, 0.1);
  position: relative;
  display: inline-block;
}

.nx-cases-title::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--nx-blue-primary),
    transparent
  );
  border-radius: 2px;
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.6);
  animation: titleGlow 2s ease-in-out infinite;
}

.nx-cases-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.nx-case-card {
  padding: 32px 28px;
  min-height: 280px;
  max-height: 280px;
  display: flex;
  flex-direction: column;
  cursor: default;
  position: relative;
  overflow: hidden;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(248, 250, 255, 0.95) 100%);
  backdrop-filter: blur(30px);
  border: 2px solid rgba(21, 101, 192, 0.15);
  border-radius: var(--nx-radius-md);
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow:
    0 8px 30px rgba(21, 101, 192, 0.12),
    0 0 40px rgba(21, 101, 192, 0.06);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: var(--nx-gradient-blue);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
    z-index: 1;
    box-shadow: 0 0 15px rgba(21, 101, 192, 0.4);
  }

  &:hover {
    transform: translateY(-8px);
    border-color: rgba(21, 101, 192, 0.35);
    box-shadow:
      0 16px 50px rgba(21, 101, 192, 0.18),
      0 0 70px rgba(21, 101, 192, 0.1);
    max-height: none;
    min-height: 280px;
    z-index: 10;

    &::before {
      transform: scaleX(1);
    }

    .nx-case-content {
      display: block;
      -webkit-line-clamp: unset;
      white-space: pre-line;
    }

    .nx-case-content-truncated {
      display: none;
    }

    .nx-case-content-full {
      display: block;
    }
  }
}

.nx-case-number {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 42px;
  font-weight: 900;
  background: var(--nx-gradient-blue);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  opacity: 0.15;
  transition: all 0.4s ease;
  z-index: 2;
  filter: drop-shadow(0 0 10px rgba(25, 118, 210, 0.3));
}

.nx-case-card:hover .nx-case-number {
  opacity: 0.3;
  transform: scale(1.1);
  filter: drop-shadow(0 0 20px rgba(25, 118, 210, 0.5));
}

.nx-case-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--nx-text-title);
  margin-bottom: 14px;
  line-height: 1.4;
  padding-right: 50px;
}

.nx-case-content {
  font-size: 14px;
  line-height: 1.7;
  color: var(--nx-text-desc);
  margin-bottom: 20px;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  text-align: left;
  text-indent: 2em;
}

.nx-case-content-full {
  display: none;
}

.nx-case-btn {
  align-self: center;
  padding: 12px 26px;
  font-size: 14px;
  background: var(--nx-gradient-blue);
  color: var(--nx-bg-deep);
  border: none;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  letter-spacing: 0.5px;

  &:hover {
    transform: translateY(-3px);
    box-shadow:
      0 8px 25px rgba(25, 118, 210, 0.5),
      0 0 20px rgba(25, 118, 210, 0.4);
  }
}

@media (max-width: 1024px) {
  .nx-cases-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .nx-cases {
    padding: 60px 20px 100px;
  }

  .nx-cases-header {
    margin-bottom: 50px;
  }

  .nx-cases-more {
    position: absolute;
    top: 65px;
    right: 0;
  }

  /* 移动端查看更多按钮改小 */
  .nx-cases-more-btn {
    padding: 8px 14px;
  }

  .nx-cases-more-btn svg {
    width: 16px;
    height: 16px;
  }

  .nx-cases-grid {
    gap: 24px;
  }

  .nx-cases-grid {
    gap: 24px;
  }

  .nx-case-card {
    padding: 28px 22px;
    min-height: 260px;
    max-height: 260px;
  }

  .nx-case-number {
    font-size: 36px;
    top: 18px;
    right: 20px;
  }

  .nx-case-title {
    font-size: 17px;
    padding-right: 45px;
    margin-bottom: 14px;
  }

  .nx-case-content {
    font-size: 13px;
    margin-bottom: 18px;
    -webkit-line-clamp: 3;
  }

  .nx-case-btn {
    padding: 10px 22px;
    font-size: 14px;
  }

  .nx-cases-subtitle {
    font-size: 1rem;
    letter-spacing: 0.2rem;
  }

  .nx-case-card:hover {
    min-height: 260px;
  }
}

/* 标题光效动画 */
@keyframes titleGlow {
  0%, 100% {
    width: 60px;
    opacity: 0.6;
  }
  50% {
    width: 120px;
    opacity: 1;
  }
}
</style>
